export type DataLayerEvent = {
    event: string;
    user_email?: string;
    user_phone?: string;
    [key: string]: unknown;
};

declare global {
    interface Window {
        dataLayer?: Record<string, unknown>[];
    }
}

const DataLayer = {
    push(event: DataLayerEvent): void {
        if (typeof window === 'undefined') {
            return;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event);
    },
};

export default DataLayer;
